import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow } from "vue";
import _imports_0 from '@/assets/images/icons/girl-running.png';
var _hoisted_1 = {
  class: "orders"
};
var _hoisted_2 = {
  key: 0,
  class: "date-filter"
};
var _hoisted_3 = {
  class: "f-bold mb-20"
};
var _hoisted_4 = {
  key: 1,
  class: "mb-10"
};
var _hoisted_5 = {
  key: 1,
  class: "d-flex fl-s-b"
};
var _hoisted_6 = {
  class: "date-picker"
};
var _hoisted_7 = {
  class: "date-picker"
};
var _hoisted_8 = {
  key: 2
};
var _hoisted_9 = {
  class: "mb-10"
};
var _hoisted_10 = {
  class: "d-flex fl-s-b"
};
var _hoisted_11 = {
  class: "date-picker"
};
var _hoisted_12 = {
  class: "date-picker"
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = {
  style: {
    "flex": "auto"
  }
};
var _hoisted_15 = {
  class: "tickets-table-wrapper"
};
var _hoisted_16 = {
  class: "tickets-table-wrapper"
};
var _hoisted_17 = {
  class: "tickets-table-wrapper"
};
var _hoisted_18 = {
  class: "customized-header d-flex flex-row fl-s-b"
};
var _hoisted_19 = {
  class: "header-title d-flex fl-col fl-j-c"
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = {
  class: "go-back-icon"
};
var _hoisted_22 = {
  class: "d-flex fl-col fl-j-c"
};
var _hoisted_23 = {
  class: "customized-body"
};
var _hoisted_24 = {
  key: 0,
  style: {
    "padding": "20px"
  }
};
var _hoisted_25 = {
  class: "body-wrapper"
};
var _hoisted_26 = {
  class: "filters-wrapper d-flex fl-col fl-s-b fl-a-c"
};
var _hoisted_27 = {
  class: "filters-row d-flex flex-row fl-s-b w-100"
};
var _hoisted_28 = {
  class: "d-flex fl-a-c fl-j-c"
};
var _hoisted_29 = ["placeholder"];
var _hoisted_30 = {
  class: "d-flex fl-a-c"
};
var _hoisted_31 = {
  class: "d-flex flex-row fl-j-c fl-a-c"
};
var _hoisted_32 = {
  class: "d-flex fl-col fl-j-c"
};
var _hoisted_33 = {
  class: "sort-title"
};
var _hoisted_34 = {
  class: "d-flex fl-a-c"
};
var _hoisted_35 = {
  class: "d-flex fl-col fl-j-c fl-a-c mr-10"
};
var _hoisted_36 = {
  class: "orders-table-wrapper"
};
var _hoisted_37 = ["onClick"];
var _hoisted_38 = {
  key: 0,
  class: "no-ticket f-bold"
};
var _hoisted_39 = {
  key: 1
};
var _hoisted_40 = {
  key: 0,
  class: "list"
};
var _hoisted_41 = ["onClick"];
var _hoisted_42 = {
  key: 1,
  class: "list"
};
var _hoisted_43 = {
  key: 0
};
var _hoisted_44 = {
  key: 0,
  class: "list"
};
var _hoisted_45 = ["onClick"];
var _hoisted_46 = {
  key: 1,
  class: "list"
};
var _hoisted_47 = {
  key: 0
};
var _hoisted_48 = {
  key: 0,
  class: "list"
};
var _hoisted_49 = ["onClick"];
var _hoisted_50 = {
  key: 1,
  class: "list"
};
var _hoisted_51 = {
  key: 0
};
var _hoisted_52 = {
  key: 1
};
var _hoisted_53 = {
  key: 2
};
var _hoisted_54 = ["onClick"];
var _hoisted_55 = {
  class: "d-flex flex-row fl-j-c mt-10"
};
var _hoisted_56 = {
  style: {
    "width": "160px"
  }
};
var _hoisted_57 = {
  key: 1,
  class: "order-details d-flex fl-col fl-j-c"
};
var _hoisted_58 = {
  class: "progressbar-wrapper d-flex fl-col fl-s-b"
};

var _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
})], -1);

var _hoisted_60 = {
  class: "loading-text"
};
var _hoisted_61 = {
  class: "one-sec-text"
};
var _hoisted_62 = ["src", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_radio = _resolveComponent("el-radio");

  var _component_el_radio_group = _resolveComponent("el-radio-group");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  var _component_el_date_picker = _resolveComponent("el-date-picker");

  var _component_el_time_select = _resolveComponent("el-time-select");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_drawer = _resolveComponent("el-drawer");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_dialog = _resolveComponent("el-dialog");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  var _component_el_pagination = _resolveComponent("el-pagination");

  var _component_el_progress = _resolveComponent("el-progress");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    "close-on-click-modal": true,
    "close-on-press-escape": true,
    "show-close": false,
    fullscreen: true,
    "custom-class": "orders-modal"
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [!_ctx.isOrderSelected ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("orders.orders")), 1)])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: _cache[12] || (_cache[12] = //@ts-ignore
        function () {
          return _ctx.goBack && _ctx.goBack.apply(_ctx, arguments);
        }),
        class: "d-flex flex-row fl-s-b"
      }, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.leftArrowIconContent,
        iconAlt: _ctx.leftArrowIconAlt,
        iconStyle: _ctx.leftArrowIconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("button.back")), 1)])]))]), _createElementVNode("div", {
        class: "close-button d-flex fl-col fl-j-c",
        onClick: _cache[13] || (_cache[13] = //@ts-ignore
        function () {
          return _ctx.close && _ctx.close.apply(_ctx, arguments);
        })
      }, [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.closeIconContent,
        iconAlt: _ctx.closeIconAlt,
        iconStyle: _ctx.closeIconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_el_drawer, {
        modelValue: _ctx.drawerVisible,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
          return _ctx.drawerVisible = $event;
        }),
        title: _ctx.drawerMode === _ctx.DrawerModes.Filter ? _ctx.$t('filters.title') : _ctx.$t('orders.data-selection'),
        direction: "rtl",
        size: 450
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_14, [_ctx.drawerMode === _ctx.DrawerModes.Filter ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            disabled: !_ctx.isApllyFilterButtonEnabled,
            loading: _ctx.isFilterLoading,
            type: "primary",
            onClick: _ctx.updateDateFilter
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
            }),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])) : _createCommentVNode("", true), _ctx.drawerMode === _ctx.DrawerModes.Settings ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _ctx.updateOrderTableSettings
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])];
        }),
        default: _withCtx(function () {
          return [_ctx.drawerMode === _ctx.DrawerModes.Filter ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("filters.date-of-visit")), 1), _createVNode(_component_el_radio_group, {
            modelValue: _ctx.dateFilterType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.dateFilterType = $event;
            }),
            class: "mb-20"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterTypeOptions, function (option) {
                return _openBlock(), _createBlock(_component_el_radio, {
                  label: option.value,
                  key: option.value
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(option.name), 1)];
                  }),
                  _: 2
                }, 1032, ["label"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"]), _ctx.dateFilterType === _ctx.OptionTypes.DateIs ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: _ctx.selectedDateShortcut,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _ctx.selectedDateShortcut = $event;
            }),
            class: "w-100"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateShortcuts, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_ctx.dateFilterType === _ctx.OptionTypes.DateAfter ? (_openBlock(), _createBlock(_component_el_checkbox, {
            key: 0,
            modelValue: _ctx.afterNowFilter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.afterNowFilter = $event;
            }),
            label: _ctx.$t('filters.now'),
            size: "large"
          }, null, 8, ["modelValue", "label"])) : _createCommentVNode("", true), _ctx.dateFilterType !== _ctx.OptionTypes.DateAfter || !_ctx.afterNowFilter ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_date_picker, {
            modelValue: _ctx.startDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return _ctx.startDate = $event;
            }),
            type: "date",
            placeholder: _ctx.t('customer.birthdate-placeholder'),
            format: _ctx.getGroupDayJsDateFormat()
          }, null, 8, ["modelValue", "placeholder", "format"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_time_select, {
            modelValue: _ctx.startTime,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return _ctx.startTime = $event;
            }),
            start: "00:00",
            step: "00:10",
            end: "23:50",
            placeholder: _ctx.$t('placeholder.time'),
            format: "HH:mm"
          }, null, 8, ["modelValue", "placeholder"])])])) : _createCommentVNode("", true)])), _ctx.dateFilterType === _ctx.OptionTypes.DateBetween ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("filters.and")), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_date_picker, {
            modelValue: _ctx.startDate2,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
              return _ctx.startDate2 = $event;
            }),
            type: "date",
            placeholder: _ctx.t('customer.birthdate-placeholder'),
            format: _ctx.getGroupDayJsDateFormat()
          }, null, 8, ["modelValue", "placeholder", "format"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_time_select, {
            modelValue: _ctx.startTime2,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
              return _ctx.startTime2 = $event;
            }),
            start: "00:00",
            step: "00:10",
            end: "23:50",
            placeholder: _ctx.$t('placeholder.time'),
            format: "HH:mm"
          }, null, 8, ["modelValue", "placeholder"])])])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.drawerMode === _ctx.DrawerModes.Settings ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_checkbox, {
            modelValue: _ctx.allColumnsEnabled,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
              return _ctx.allColumnsEnabled = $event;
            }),
            indeterminate: _ctx.isIndeterminate,
            onChange: _ctx.handleAllColumnsChange,
            label: _ctx.$t('orders.select-all'),
            large: ""
          }, null, 8, ["modelValue", "indeterminate", "onChange", "label"]), _createVNode(_component_el_divider, {
            style: {
              "margin": "5px 0"
            }
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTableConfigCopy, function (item) {
            return _openBlock(), _createElementBlock("div", {
              key: item.id
            }, [_createVNode(_component_el_checkbox, {
              modelValue: item.enabled,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.enabled = $event;
              },
              label: _ctx.$t(item.label),
              large: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])]);
          }), 128))])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _ctx.showTicketsListModal,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return _ctx.showTicketsListModal = $event;
        }),
        width: "700px",
        title: _ctx.$t('button.products'),
        "custom-class": "tickets-list-popup"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_table, {
            data: _ctx.ticketsList
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                prop: "id",
                label: "ID",
                width: "auto"
              }), _createVNode(_component_el_table_column, {
                prop: "name",
                label: _ctx.$t('orders.name'),
                width: "auto"
              }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                prop: "productName",
                label: _ctx.$t('common.product-name')
              }, null, 8, ["label"])];
            }),
            _: 1
          }, 8, ["data"])])];
        }),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _ctx.showAddonsListModal,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return _ctx.showAddonsListModal = $event;
        }),
        width: "700px",
        title: _ctx.$t('orders.addons'),
        "custom-class": "tickets-list-popup"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_table, {
            data: _ctx.orderAddonsList
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                prop: "name",
                label: _ctx.$t('orders.name'),
                width: "auto"
              }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                prop: "quantity",
                label: _ctx.$t('orders.quantity')
              }, null, 8, ["label"])];
            }),
            _: 1
          }, 8, ["data"])])];
        }),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: _ctx.showRetailsListModal,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
          return _ctx.showRetailsListModal = $event;
        }),
        width: "700px",
        title: _ctx.$t('orders.retail-product'),
        "custom-class": "tickets-list-popup"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_table, {
            data: _ctx.retailsList
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                prop: "name",
                label: _ctx.$t('orders.name'),
                width: "auto"
              }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
                prop: "quantity",
                label: _ctx.$t('orders.quantity')
              }, null, 8, ["label"])];
            }),
            _: 1
          }, 8, ["data"])])];
        }),
        _: 1
      }, 8, ["modelValue", "title"]), _createElementVNode("div", _hoisted_23, [!_ctx.isOrderSelected ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
        class: "filter-button search-input",
        type: "search",
        placeholder: _ctx.$t('orders.reference-seller-customer') + '...',
        "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
          return _ctx.bookingReferenceQuery = $event;
        }),
        onInput: _cache[15] || (_cache[15] = //@ts-ignore
        function () {
          return _ctx.queryOrders && _ctx.queryOrders.apply(_ctx, arguments);
        })
      }, null, 40, _hoisted_29), [[_vModelText, _ctx.bookingReferenceQuery]]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_button, {
        class: _normalizeClass({
          active: _ctx.isFilterApplied
        }),
        icon: _ctx.SetUp,
        type: _ctx.isFilterApplied ? 'success' : '',
        plain: "",
        style: {
          "margin": "0",
          "border-radius": "4px 0 0 4px"
        },
        onClick: _cache[16] || (_cache[16] = function ($event) {
          return _ctx.toggleDrawer(_ctx.DrawerModes.Filter);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("filters.title")), 1)];
        }),
        _: 1
      }, 8, ["class", "icon", "type"]), _createVNode(_component_el_button, {
        icon: _ctx.Delete,
        type: "warning",
        plain: "",
        style: {
          "margin": "0",
          "border-radius": "0 4px 4px 0"
        },
        disabled: !_ctx.isFilterApplied,
        onClick: _ctx.clearDateFilter
      }, null, 8, ["icon", "disabled", "onClick"])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("field.sort-by") + ":"), 1)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_select, {
        modelValue: _ctx.selectedSortingOption,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return _ctx.selectedSortingOption = $event;
        }),
        style: {
          "width": "150px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_option, {
            label: _ctx.$t('orders.creation-date'),
            value: "created_at"
          }, null, 8, ["label"]), _createVNode(_component_el_option, {
            label: _ctx.$t('filters.date-of-visit'),
            value: "booking_start_dates"
          }, null, 8, ["label"])];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_button, {
        class: _normalizeClass(["sort-arrow", {
          activeArrow: _ctx.selectedSortingDirection === _ctx.SortingDirections.Ascending
        }]),
        icon: _ctx.CaretTop,
        style: {
          "margin": "0",
          "padding": "0",
          "border": "none"
        },
        onClick: _cache[18] || (_cache[18] = function ($event) {
          return _ctx.setSortingDirection(_ctx.SortingDirections.Ascending);
        })
      }, null, 8, ["class", "icon"]), _createVNode(_component_el_button, {
        class: _normalizeClass(["sort-arrow", {
          activeArrow: _ctx.selectedSortingDirection === _ctx.SortingDirections.Descending
        }]),
        icon: _ctx.CaretBottom,
        style: {
          "margin": "0",
          "padding": "0",
          "border": "none"
        },
        onClick: _cache[19] || (_cache[19] = function ($event) {
          return _ctx.setSortingDirection(_ctx.SortingDirections.Descending);
        })
      }, null, 8, ["class", "icon"])])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: _normalizeClass(["filter-button", {
          active: _ctx.bookingsPaymentFilter === _ctx.BookingPaymentOptions.All
        }]),
        onClick: _cache[20] || (_cache[20] = function ($event) {
          return _ctx.updateBookingsPaymentFilter(_ctx.BookingPaymentOptions.All);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("orders.all")), 1)];
        }),
        _: 1
      }, 8, ["class"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: _normalizeClass(["filter-button", {
          active: _ctx.bookingsPaymentFilter === _ctx.BookingPaymentOptions.Paid
        }]),
        onClick: _cache[21] || (_cache[21] = function ($event) {
          return _ctx.updateBookingsPaymentFilter(_ctx.BookingPaymentOptions.Paid);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("orders.paid")), 1)];
        }),
        _: 1
      }, 8, ["class"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: _normalizeClass(["filter-button", {
          active: _ctx.bookingsPaymentFilter === _ctx.BookingPaymentOptions.NotPaid
        }]),
        onClick: _cache[22] || (_cache[22] = function ($event) {
          return _ctx.updateBookingsPaymentFilter(_ctx.BookingPaymentOptions.NotPaid);
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("orders.non-paid")), 1)];
        }),
        _: 1
      }, 8, ["class"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: "settings-button",
        icon: _ctx.Setting,
        size: "large",
        circle: "",
        onClick: _cache[23] || (_cache[23] = function ($event) {
          return _ctx.toggleDrawer(_ctx.DrawerModes.Settings);
        })
      }, null, 8, ["icon"])])])])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_table, {
            ref: "table",
            data: _ctx.parsedOrders,
            "row-key": "id",
            "empty-text": _ctx.$t('orders.no-orders'),
            height: "65vh",
            "row-style": "background-color:rgba(48, 170, 188, 0.05);color:#333333",
            border: true
          }, {
            default: _withCtx(function () {
              return [_ctx.isColumnEnabled(_ctx.OrderTableColumns.REFERENCE) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                "show-overflow-tooltip": "",
                label: _ctx.$t('orders.booking-reference'),
                "min-width": "200"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("p", {
                    class: "link",
                    onClick: function onClick($event) {
                      return (
                        /*selectOrderForEditing*/
                        _ctx.orderClick(scope.row)
                      );
                    }
                  }, _toDisplayString(scope.row.reference), 9, _hoisted_37)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.CUSTOMER) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                prop: "customerFullName",
                label: _ctx.$t('orders.customer-full-name'),
                "show-overflow-tooltip": "",
                "min-width": "220"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.DATE_OF_VISIT) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                prop: "firstStartDate",
                "show-overflow-tooltip": "",
                label: _ctx.$t('filters.date-of-visit'),
                "min-width": "290"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.QUANTITY) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                prop: "quantity",
                label: _ctx.$t('orders.quantity'),
                "show-overflow-tooltip": "",
                "min-width": "100"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.TICKETS) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                "show-overflow-tooltip": "",
                label: _ctx.$t('completeorder.tickets'),
                "min-width": "120"
              }, {
                default: _withCtx(function (scope) {
                  return [!scope.row.bookingTickets ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.$t("orders.no-tickets")), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_39, [scope.row.bookingTickets.length > 4 ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.bookingTickets.slice(0, 4), function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      class: "f-bold",
                      key: index
                    }, _toDisplayString(item.name), 1);
                  }), 128)), _createElementVNode("li", {
                    class: "link",
                    onClick: function onClick($event) {
                      return _ctx.openTicketsListModal(scope.row);
                    }
                  }, _toDisplayString(_ctx.$t("button.show-more")), 9, _hoisted_41)])) : (_openBlock(), _createElementBlock("ul", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.bookingTickets, function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      class: "f-bold",
                      key: index
                    }, _toDisplayString(item.name), 1);
                  }), 128))]))]))];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.RETAILS) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                "show-overflow-tooltip": "",
                label: _ctx.$t('orders.retail-product'),
                "min-width": "150"
              }, {
                default: _withCtx(function (scope) {
                  return [scope.row.bookingRetails ? (_openBlock(), _createElementBlock("div", _hoisted_43, [scope.row.bookingRetails.length > 4 ? (_openBlock(), _createElementBlock("ul", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.bookingRetails.slice(0, 4), function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: index
                    }, _toDisplayString("x".concat(item.quantity, " ").concat(item.name)), 1);
                  }), 128)), _createElementVNode("li", {
                    class: "link",
                    onClick: function onClick($event) {
                      return _ctx.openRetailsListModal(scope.row);
                    }
                  }, _toDisplayString(_ctx.$t("button.show-more")), 9, _hoisted_45)])) : (_openBlock(), _createElementBlock("ul", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.bookingRetails, function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: index
                    }, _toDisplayString("x".concat(item.quantity, " ").concat(item.name)), 1);
                  }), 128))]))])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.ADDONS) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                "show-overflow-tooltip": "",
                label: _ctx.$t('orders.addons'),
                "min-width": "120"
              }, {
                default: _withCtx(function (scope) {
                  return [_ctx.addonsList[scope.row.id] ? (_openBlock(), _createElementBlock("div", _hoisted_47, [_ctx.addonsList[scope.row.id] && _ctx.addonsList[scope.row.id].length > 4 ? (_openBlock(), _createElementBlock("ul", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addonsList[scope.row.id].slice(0, 4), function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: index
                    }, _toDisplayString("x".concat(item.quantity, " ").concat(item.name)), 1);
                  }), 128)), _createElementVNode("li", {
                    class: "link",
                    onClick: function onClick($event) {
                      return _ctx.openAddonsListModal(scope.row.id);
                    }
                  }, _toDisplayString(_ctx.$t("button.show-more")), 9, _hoisted_49)])) : (_openBlock(), _createElementBlock("ul", _hoisted_50, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addonsList[scope.row.id] || [], function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: index
                    }, _toDisplayString("x".concat(item.quantity, " ").concat(item.name)), 1);
                  }), 128))]))])) : _createCommentVNode("", true)];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.CREATION_DATE) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                prop: "createdAt",
                label: _ctx.$t('orders.creation-date'),
                "show-overflow-tooltip": "",
                "min-width": "200"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.PAYMENT_STATUS) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                prop: "bookingPaymentStatus",
                label: _ctx.$t('orders.payment-status'),
                "show-overflow-tooltip": "",
                "min-width": "200"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.SELLER) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                prop: "sellerFullName",
                label: _ctx.$t('orders.seller'),
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.CHANNEL) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                prop: "bookingChannel",
                label: _ctx.$t('orders.booking-channel'),
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.TOTAL_VALUE) ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                prop: "totalValue",
                label: _ctx.$t('orders.total-price'),
                "show-overflow-tooltip": "",
                "min-width": "120"
              }, null, 8, ["label"])) : _createCommentVNode("", true), _ctx.isColumnEnabled(_ctx.OrderTableColumns.TEAMS) && _ctx.showTeamsColumn ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                "show-overflow-tooltip": "",
                label: _ctx.$t('completeorder.teams'),
                "min-width": "120"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("div", null, [scope.row.requireTeams ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: function onClick($event) {
                      return _ctx.selectOrderForEditing(scope.row, true);
                    },
                    type: "text"
                  }, {
                    default: _withCtx(function () {
                      return [scope.row.teamsStatus === _ctx.BookingTeamsStatus.Completed ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.$t("completeorder.modify")), 1)) : _createCommentVNode("", true), scope.row.teamsStatus === _ctx.BookingTeamsStatus.NotStarted ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.$t("completeorder.add-teams")), 1)) : _createCommentVNode("", true), scope.row.teamsStatus === _ctx.BookingTeamsStatus.InProgress ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.$t("completeorder.complete-teams")), 1)) : _createCommentVNode("", true)];
                    }),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true)])];
                }),
                _: 1
              }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
                fixed: "right",
                "show-overflow-tooltip": "",
                "min-width": "100"
              }, {
                default: _withCtx(function (scope) {
                  return [_createElementVNode("div", null, [_createElementVNode("div", null, [_createElementVNode("div", {
                    class: "edit-order-btn d-flex fl-col fl-j-c",
                    onClick: function onClick($event) {
                      return (
                        /*selectOrderForEditing*/
                        _ctx.orderClick(scope.row)
                      );
                    }
                  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t("button.edit-order")), 1)], 8, _hoisted_54)])])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data", "empty-text"])];
        }),
        _: 1
      })])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        total: _ctx.ordersCount,
        "page-size": _ctx.pageSize,
        "current-page": _ctx.currentPage,
        onCurrentChange: _ctx.changeCurrentPage
      }, null, 8, ["total", "page-size", "current-page", "onCurrentChange"])]), _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_select, {
        modelValue: _ctx.pageSize,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = function ($event) {
          return _ctx.pageSize = $event;
        }),
        class: "w-100"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([{
            value: 10,
            label: "10 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 25,
            label: "25 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 50,
            label: "50 ".concat(_ctx.$t('common.per-page'))
          }, {
            value: 100,
            label: "100 ".concat(_ctx.$t('common.per-page'))
          }], function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])])])])) : _createCommentVNode("", true), _ctx.isOrderSelected ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_withDirectives(_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", null, [_createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t("common.loading")), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_progress, {
        percentage: 70,
        indeterminate: true,
        "stroke-width": "26",
        "show-text": false
      })]), _createElementVNode("div", _hoisted_61, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("common.one-sec")), 1)])], 512), [[_vShow, !_ctx.isOrderViewLoaded]]), _withDirectives(_createElementVNode("iframe", {
        src: _ctx.frameSource,
        frameborder: "0",
        width: "100%",
        height: _ctx.frameHeight
      }, null, 8, _hoisted_62), [[_vShow, _ctx.isOrderViewLoaded]])])) : _createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}